/**
 * Can be extended with more types. Inspired by Bootstrap
 */
export enum ActionType {
  PRIMARY,
  DANGER
}
